export default "__VITE_ASSET__7e5e9e2d__"